import React, { useEffect, useState } from 'react';

import { BaseControlProps } from '../../models/BaseControlProps';
import { ReactComponent as SvgLogo } from "../../components/Header/logo.svg";

import ReCAPTCHA from 'react-google-recaptcha';
import { AuthUserPasswordResetRequest } from '../../models/AuthUserPasswordResetRequest';
import { UtilService } from '../../services/UtilService';
import { AuthAPIService } from '../../services/AuthAPIServices';
// import { SecurityQuestion } from '../../models/SecurityQuestion';
import { useNavigate } from 'react-router-dom';
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { Box, Button, CircularProgress, FormControl, FormHelperText, FormLabel, TextField, Typography } from '@mui/material';


const Card = styled(MuiCard)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
      width: '450px',
    },
    boxShadow:
      'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    ...theme.applyStyles('dark', {
      boxShadow:
        'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
    }),
  }));
  
  const MainContainer = styled(Stack)(({ theme }) => ({
     padding: 20,
     marginTop: '10vh',
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      zIndex: -1,
      inset: 0
    },
  }));

const ForgetPassword = (props: BaseControlProps) => {
    const [scope,apply] = React.useState<AuthUserPasswordResetRequest>({userName: ""});
    //const [securityQuestion, setSecurityQuestion] = useState<SecurityQuestion[] | null>(null);
    const authService = new AuthAPIService();
    //const [showValidateQuestion, setShowValidateQuestion] = useState(false);
    const navigate = useNavigate();
    const [emailError, setEmailError] = React.useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = React.useState('');
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
    const [captchError, isCaptchaError] = useState(false);
    const [inputValid, isInputValid] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);


    function applyScope(){
        apply(UtilService.cloneObject(scope));
    }

    const handleCaptchaChange = (value: string | null) => {
        if (value) {
          setIsCaptchaVerified(true);
        } else {
          setIsCaptchaVerified(false);
        }
      };

    const requestResetPassword = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!inputValid) { return; }
        setLoading(true);
        authService.requestPasswordReset(scope).then((response) => {
            setLoading(false);
            if (response.error)
            {
                if (props.isMessageInfoShow && props.setMessageInfo) {
                    props.setMessageInfo(UtilService.getErrorMessageInfo(response.error));
                    props.isMessageInfoShow(true);
                }
            }
            else{
                if(response.response?.emailSent){
                    if (props.isMessageInfoShow && props.setMessageInfo) {
                        props.setMessageInfo(UtilService.getSucessMessageInfo("Password reset email have been emailed to you."));
                        props.isMessageInfoShow(true);
                    }

                    setTimeout(() => {
                        navigate('/login');
                    }, 3000);
                }
                else{
                    if (props.isMessageInfoShow && props.setMessageInfo) {
                        props.setMessageInfo(UtilService.getErrorMessageInfo("We are sorry, but we couldn’t find your details, please contact Mercer"));
                        props.isMessageInfoShow(true);
                    }
                }
            }
        });
    }

    const validateInputs = () => {
        const email = document.getElementById('email') as HTMLInputElement;
        scope.userName = email.value;
        applyScope();
        isInputValid(true);
        
        if (!isCaptchaVerified) {
            isCaptchaError(true);
            isInputValid(false);
        } else {
            isCaptchaError(false);
        }

        if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
          setEmailError(true);
          setEmailErrorMessage('Please enter a valid email address.');
          isInputValid(false);
        } else {
          setEmailError(false);
          setEmailErrorMessage('');
        }
    
        return inputValid;
    };

    return(
        <MainContainer direction="column" justifyContent="space-between">
            <Card variant='outlined'>
                <div className="logo-container">
                    <SvgLogo focusable={false} viewBox="0 0 500 150" />
                </div>
                <Typography
                    component="h1"
                    variant="h6"
                >
                    Forgot your Password!
                </Typography>
                <Box
                    component="form"
                    onSubmit={requestResetPassword}
                    sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
                >
                    <FormControl>
                        <FormLabel htmlFor='email'>Email:</FormLabel>
                        <TextField 
                            required
                            fullWidth
                            id="email"
                            autoComplete='email'
                            variant='outlined'
                            error={emailError}
                            helperText={emailErrorMessage}
                            color={emailError ? 'error' : 'primary' }
                        />
                    </FormControl>
                    <FormControl error={captchError}>
                        {/* Google reCAPTCHA v2 */}
                        <div style={{ margin: '20px 0' }}>
                            <ReCAPTCHA
                                sitekey="6LdWZmgqAAAAANm-U9o1q9EGk1srfrfkIv74ampz" // Replace with your site key
                                onChange={handleCaptchaChange}
                            />
                        </div>
                        {captchError && <FormHelperText error>Please verify the reCAPTCHA.</FormHelperText>}
                    </FormControl>
                    <Button
                        type='submit'
                        fullWidth
                        variant='contained'
                        onClick={validateInputs}
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                        sx={{
                            '&.Mui-disabled': {
                                color: (theme) => theme.palette.primary.contrastText,
                            }
                        }}
                    >
                        {loading ? 'Loading...' : 'Reset Password'}
                    </Button>
                </Box>

            </Card>
        </MainContainer>
    );
}
export default ForgetPassword;